export enum VALIDATION_ERRORS {
	NOT_VALID_PHONE_FORMAT = "Телефон введён неверно",
	PASSWORD_NOT_MATCH = "Пароли не совпадают",
	PASSWORD_LESS_8 = "Пароль меньше 8 символов",
	PASSWORD_MORE_16 = "Пароль больше 16 символов",
	NO_PASSWORD_VALUE = "Введите пароль",
	NOT_VALID_EMAIL_FORMAT = "Неверный формат Email, пример: ivan@mail.ru",
	INCORRECT_NAME = "Введите корректное имя (буквы, пробелы)",
	REQUIRED_VALUE = "Заполните поле",
	REQUIRED_RATING = "Укажите оценку",
	FILL_SECTIONS = "Заполните секции",
}
